import CopyToClipboard from 'react-copy-to-clipboard'
import { toast } from 'react-toastify'

const TR = ({ name, description, value }) => {
    return (
        <tr className='border-bottom'>
            <td style={{fontSize: 12}}>{name}</td>
            <td style={{fontSize: 12}}>{description}</td>
            <td style={{fontSize: 12, textAlign: 'right'}}>
                <CopyToClipboard 
                    text={`{${value}}`}
                    onCopy={() => {
                        toast.info(`{${value}} copied to clipboard.`)
                    }}
                >
                    <div><i className="fas fa-copy cursor-pointer text-info mr-2" /> {`{${value}}`}</div>
                </CopyToClipboard>
            </td>
        </tr>
    )
}

const ModalDivisionOverride = () => (
    <div id="archk-field-explanation" style={{display: 'none'}}>
        <div 
            onClick={() => {
                const el = document.getElementById('archk-field-explanation');
                el.style.display = 'none'
            }}
            style={{ 
                position: 'fixed',
                zIndex: 1000,
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                background: 'rgba(0,0,0,.5)' 
            }}
        />
        
        <div 
            style={{ 
                position: 'fixed',
                zIndex: 1050,
                top: 50,
                bottom: 50,
                left: 0,
                right: 0,
                width: 1000,
                marginLeft: 'auto',
                marginRight: 'auto',
                maxWidth: '90%',
                background: 'white',
                overflow: 'auto'
            }}
        >
            <table className='table'>
                <thead>
                    <tr>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Matter Fields</th>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Description</th>
                        <th style={{fontSize: 12, paddingBottom: 4, textAlign: 'right'}}>Value</th>
                    </tr>
                </thead>

                <tbody>
                    <TR 
                        name="Matter ID"
                        description="The id of the matter"
                        value="matter.id"
                    />
                    <TR 
                        name="Matter Name"
                        description="The name of the matter"
                        value="matter.name"
                    />
                    <TR 
                        name="Matter Identifier"
                        description="The external identifier of the matter like a case ID"
                        value="matter.identifier"
                    />
                    <TR 
                        name="Matter Current Step Name"
                        description="The name of the current step the matter is on"
                        value="matter.current_step_name"
                    />
                    
                </tbody>
            </table>

            <table className='table'>
                <thead>
                    <tr>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Matter Roles</th>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Description</th>
                        <th style={{fontSize: 12, paddingBottom: 4, textAlign: 'right'}}>Value</th>
                    </tr>
                </thead>

                <tbody>
                    <TR 
                        name="Title"
                        description="The title of the user"
                        value="role.ROLE_ID.title"
                    />
                    <TR 
                        name="First Name"
                        description="The first name of the user"
                        value="role.ROLE_ID.first_name"
                    />
                    <TR 
                        name="Last Name"
                        description="The last name of the user"
                        value="role.ROLE_ID.last_name"
                    />
                    <TR 
                        name="Email Address"
                        description="The email address of the user"
                        value="role.ROLE_ID.email"
                    />
                    <TR 
                        name="Phone Number"
                        description="The phone number of the user"
                        value="role.ROLE_ID.phone"
                    />

                    <TR 
                        name="Address Line 1"
                        description="The street address of the user"
                        value="role.ROLE_ID.address_line_2"
                    />
                    <TR 
                        name="Address Line 2"
                        description="The apartment/suite number"
                        value="role.ROLE_ID.address_line_2"
                    />
                    <TR 
                        name="City"
                        description="The city of the user"
                        value="role.ROLE_ID.city"
                    />
                    <TR 
                        name="State"
                        description="The state of the user"
                        value="role.ROLE_ID.state"
                    />
                    <TR 
                        name="Zip Code"
                        description="The zip code of the user"
                        value="role.ROLE_ID.zip_code"
                    />
                    <TR 
                        name="Hourly Rate"
                        description="The internal hourly rate of the user"
                        value="role.ROLE_ID.rate_hourly"
                    />
                    <TR 
                        name="Billable Rate"
                        description="The hourly billable rate of the user"
                        value="role.ROLE_ID.rate_billable"
                    />
                </tbody>
            </table>

            <table className='table'>
                <thead>
                    <tr>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Matter Parties</th>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Description</th>
                        <th style={{fontSize: 12, paddingBottom: 4, textAlign: 'right'}}>Value</th>
                    </tr>
                </thead>

                <tbody>
                    <TR 
                        name="First Name"
                        description="The first name of the party"
                        value="party.PARTY_ID.first_name"
                    />
                    <TR 
                        name="Last Name"
                        description="The last name of the party"
                        value="party.PARTY_ID.last_name"
                    />
                    <TR 
                        name="Email Address"
                        description="The email address of the party"
                        value="party.PARTY_ID.email"
                    />
                    <TR 
                        name="Phone Number"
                        description="The phone number of the party"
                        value="party.PARTY_ID.phone"
                    />

                    <TR 
                        name="Address Line 1"
                        description="The street address of the party"
                        value="party.PARTY_ID.address_line_2"
                    />
                    <TR 
                        name="Address Line 2"
                        description="The apartment/suite number"
                        value="party.PARTY_ID.address_line_2"
                    />
                    <TR 
                        name="City"
                        description="The city of the party"
                        value="party.PARTY_ID.city"
                    />
                    <TR 
                        name="state"
                        description="The state of the party"
                        value="party.PARTY_ID.state"
                    />
                    <TR 
                        name="zip code"
                        description="The zip code of the party"
                        value="party.PARTY_ID.zip_code"
                    />
                </tbody>
            </table>
            
            <table className='table'>
                <thead>
                    <tr>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Matter Locations</th>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Description</th>
                        <th style={{fontSize: 12, paddingBottom: 4, textAlign: 'right'}}>Value</th>
                    </tr>
                </thead>

                <tbody>
                    <TR 
                        name="Name"
                        description="The name of the location"
                        value="location.LOCATION_ID.name"
                    />
                    <TR 
                        name="Email Address"
                        description="The email address of the location"
                        value="location.LOCATION_ID.email"
                    />
                    <TR 
                        name="Phone Number"
                        description="The phone number of the location"
                        value="location.LOCATION_ID.phone"
                    />
                    <TR 
                        name="Fax Number"
                        description="The fax number of the location"
                        value="location.LOCATION_ID.fax_number"
                    />

                    <TR 
                        name="Address Line 1"
                        description="The street address of the location"
                        value="location.LOCATION_ID.address_line_2"
                    />
                    <TR 
                        name="Address Line 2"
                        description="The apartment/suite number"
                        value="location.LOCATION_ID.address_line_2"
                    />
                    <TR 
                        name="City"
                        description="The city of the location"
                        value="location.LOCATION_ID.city"
                    />
                    <TR 
                        name="state"
                        description="The state of the location"
                        value="location.LOCATION_ID.state"
                    />
                    <TR 
                        name="zip code"
                        description="The zip code of the location"
                        value="location.LOCATION_ID.zip_code"
                    />
                </tbody>
            </table>
            
            <table className='table'>
                <thead>
                    <tr>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Custom Fields</th>
                        <th style={{fontSize: 12, paddingBottom: 4}}>Description</th>
                        <th style={{fontSize: 12, paddingBottom: 4, textAlign: 'right'}}>Value</th>
                    </tr>
                </thead>

                <tbody>
                    <TR 
                        name="Field ID"
                        description="You can find the ID of the custom field you are looking for on your admin dashboard"
                        value="custom.FIELD_ID"
                    />
                </tbody>
            </table>
          
            <table className='table'>
                <thead>
                    <tr>
                        <th style={{fontSize: 12, paddingBottom: 4}}>If Statements</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td style={{fontSize: 12}}>To create an if statement you may use any field above with the syntax {`{#FIELD}....{/FIELD}`}. Anything in the middle of this will show on the document if the field you have selected is not empty. For instance if you want to conditionally add a clause to a contract if a custom field is found you would add {`{#custom.6376b82424e2233278fa3571}Due to the laws in your state this contract can be cancelled anytime within 30 days of signing it.{/custom.6376b82424e2233278fa3571}`}. This will then be shown on the document if the custom field with the ID 6376b82424e2233278fa3571 is no blank on the matter.</td>
                    </tr>
                </tbody>
            </table>
        </div>


    </div>

)

export default ModalDivisionOverride